export const GET_BILL_UPLOAD_GUIDELINES_SUCCESS = 'GET_BILL_UPLOAD_GUIDELINES_SUCCESS';
export const GET_BILL_UPLOAD_GUIDELINES_FAIL = 'GET_BILL_UPLOAD_GUIDELINES_FAIL';